import React from 'react';
import { AssetExplorer } from 'components/AssetExplorer';

/** Beam on Screen backend prefix on st-ck-server (`/bos/...`). */
export const BEAM_ON_SCREEN_ASSETS_API_BASE_PATH = '/bos';

/**
 * Beam on Screen → Assets (`/#/beamonscreen/assets`).
 *
 * Same explorer UI as Asset Management, pointed at the `beamonscreen` server module (`/bos`).
 * Both modules share one asset library on the server (`AE-Folder` / `AE-Asset`, same S3 layout),
 * so assets published here are the same assets seen under Asset Management.
 */
export const Assets: React.FC = () => (
  <AssetExplorer
    apiBasePath={BEAM_ON_SCREEN_ASSETS_API_BASE_PATH}
    title="Assets"
    uiStateStorageKey="beamonscreen-assets-ui-state"
    sidebarWidthStorageKey="beamOnScreenAssets.sidebarWidth"
  />
);
